import React from 'react';
import { ELIGIBILITY } from '@tmap/mmm-core/commonApp/funnelCategories';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { LinearProgress } from '@tmap/mmm-style-guide/src/Progress';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Chip } from '@tmap/mmm-style-guide/src/Chip';
import { getCurrentStepNumber, getNumberOfSteps } from '../../lib/commonApp/stageOrder';

function ProgressBar(props) {
  const {
    stage,
    incentive,
  } = props;
  const currentStep = getCurrentStepNumber(stage);
  const numOfSteps = getNumberOfSteps();
  const value = (100 * currentStep) / numOfSteps;
  if (stage === ELIGIBILITY) return null;
  return (
    <Grid container spacing={3}>
      <Grid item xs>
        {incentive && <Typography variant='body1' mt={0.5}>{incentive?.locationText} Application</Typography>}
      </Grid>
      <Grid item>
        <Chip label='Application in Progress' color='secondary' />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs>
            <LinearProgress
              color='secondary'
              variant='determinate'
              value={value}
              sx={{ height: '4px', marginTop: 1 }}
            />
          </Grid>
          <Grid item>
            <Typography variant='body2' color='textSecondary'>
              {currentStep} / {numOfSteps}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ProgressBar;